import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ChatProvider } from './context/ChatContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';

const ServicePage = lazy(() => import('./pages/ServicePage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <ChatProvider>
      <div className="min-h-screen flex flex-col">
        <a className="skip-link" href="#main">Zum Inhalt springen</a>
        <ScrollToTop />
        <Header />
        <main id="main" className="flex-1">
          <ErrorBoundary>
            <Suspense fallback={
              <div className="min-h-[60vh] flex items-center justify-center">
                <div className="w-8 h-8 border-4 border-signal border-t-transparent rounded-full animate-spin" />
              </div>
            }>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/leistungen/:slug" element={<ServicePage />} />
                <Route path="/impressum" element={<LegalPage page="impressum" />} />
                <Route path="/datenschutz" element={<LegalPage page="datenschutz" />} />
                <Route path="/404" element={<NotFoundPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </ChatProvider>
  );
}

export default App;
